"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Settings = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _detailsComponent = _interopRequireDefault(require("../details-component/details-component"));

var _settingsItem = _interopRequireDefault(require("./settings-item"));

require("./settings.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Settings = function Settings(_ref) {
  var visibleColumns = _ref.visibleColumns,
      onToggleColumn = _ref.onToggleColumn,
      settings = _ref.settings,
      hasPermissions = _ref.hasPermissions;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-board-settings-container"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.columns.General",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-board-settings"
  }, /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "name",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'name';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.name",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "externalId",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'externalId';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.externalId",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "assetId",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'assetId';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.assetName",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "status",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'status';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.status",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "realStartTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'realStartTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.realStartTime",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "realEndTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'realEndTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.realEndTime",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "arrivalDeviation",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'arrivalDeviation';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.arrivalDeviation",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "eta",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'eta';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.tourEta",
      tagName: "span"
    })
  }), hasPermissions(['module.tour.remainingDrivingTime']) && /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "remainingDrivingTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'remainingDrivingTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.remainingDrivingTime",
      tagName: "span"
    })
  }), hasPermissions(['module.greenyard.tour']) && /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "storingPlaces",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'storingPlaces';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.storingPlaces",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "actions",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'actions';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.actions",
      tagName: "span"
    })
  }))), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.columns.POIBased",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-board-settings"
  }, /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "earliestStartTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'earliestStartTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.tourDate",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "plannedStartTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'plannedStartTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.startPoiTime",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "plannedEndTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'plannedEndTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.endPoiTime",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "startPoi",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'startPoi';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.startPoi",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "endPoi",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'endPoi';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.endPoi",
      tagName: "span"
    })
  }))), hasPermissions(['module.tour.timedStartEnd']) && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.columns.TimeBased",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-board-settings"
  }, /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "scheduledStartTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'scheduledStartTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.scheduledStartTime",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "scheduledEndTime",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'scheduledEndTime';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.scheduledEndTime",
      tagName: "span"
    })
  }))), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.columns.Alarms",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-board-settings"
  }, /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "assignedAlarms",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'assignedAlarms';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.assignedAlarms",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "currentAlarm",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'currentAlarm';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.currentAlarm",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "triggeredAlarms",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'triggeredAlarms';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.triggeredAlarms",
      tagName: "span"
    })
  }))), (hasPermissions(['module.dcc.systemexchange.read']) || hasPermissions(['module.tour.road'])) && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.columns.Sharing",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-board-settings"
  }, hasPermissions(['module.tour.road']) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "customerPortalIds",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'customerPortalIds';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.customerPortalIds",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "serviceProviderPortalId",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'serviceProviderPortalId';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.serviceProviderPortalId",
      tagName: "span"
    })
  })), hasPermissions(['module.dcc.systemexchange.read']) && /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "rtvProvider",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'rtvProvider';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.rtvProvider",
      tagName: "span"
    })
  }))), hasPermissions(['module.tour.rail']) && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.columns.rail",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-board-settings"
  }, /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "train",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'train';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.train",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "customerName",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'customerName';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.customerName",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "railwayUndertaking",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'railwayUndertaking';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.railwayUndertaking",
      tagName: "span"
    })
  }), /*#__PURE__*/_react["default"].createElement(_settingsItem["default"], {
    dataKey: "loaded",
    onToggle: onToggleColumn,
    visible: visibleColumns.some(function (col) {
      return col.dataKey === 'loaded';
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.headers.loaded",
      tagName: "span"
    })
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-defaults-container"
  }, settings.tourDefaults && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    className: "tour-defaults-section-header",
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.tourDefaults",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_detailsComponent["default"], {
    tour: settings.tourDefaults
  }))));
};

exports.Settings = Settings;
Settings.propTypes = {
  hasPermissions: _propTypes["default"].func.isRequired,
  visibleColumns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    dataKey: _propTypes["default"].string.isRequired
  })),
  onToggleColumn: _propTypes["default"].func,
  settings: _propTypes["default"].shape({
    tourDefaults: _propTypes["default"].shape({})
  }),
  user: _propTypes["default"].shape({}).isRequired
};

var noop = function noop() {};

Settings.defaultProps = {
  visibleColumns: [],
  onToggleColumn: noop,
  settings: {
    tourDefaults: {}
  }
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(null)(Settings);

exports["default"] = _default;